import { Injectable } from '@angular/core'
import { JsonApiDatastore } from 'angular2-jsonapi/dist/services/json-api-datastore.service'
import { Observable } from 'rxjs/Observable'
import { ExtratoDeAntecipacoes } from '../../pkw-data/collect/extrato/extrato-de-antecipacoes.model'
import { ExtratoDeRecebimentos } from '../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { ExtratoDeVendas } from '../../pkw-data/collect/extrato/extrato-de-vendas.model'
import { Binario } from '../../pkw-data/core/binario.model'
import { LocalDateConverter } from '../../pkw-data/core/converters/local-date.converter'
import { CriadoresDeBinario } from '../../pkw-data/core/criador-de-binario.enum'
import { PkwDatastore } from '../../pkw-data/pkw-datastore'
import { ExtratoDeVendasService } from '../extratos-de-vendas/shared/extrato-de-vendas.service'
import { FiltroExtrato } from '../shared/filtro-extrato'
import { DadosRelatorio } from './dados-relatorio'
import { OpcoesRelatorio, TiposDeMovimentoRelatorio } from './opcoes-relatorio.interface'

@Injectable()
export class RelatorioService {
    constructor(
        private pkwDatastore: PkwDatastore,
        private extratoDeVendasService: ExtratoDeVendasService
    ) {}

    gerarBinario(opcoes: OpcoesRelatorio) {
        const values = {
            criador: CriadoresDeBinario.Relatorio,
            opcoes: {
                idDaEmpresa: opcoes.empresa && opcoes.empresa.id,
                idDaOperadora: opcoes.operadora && opcoes.operadora.id,
                inicio: LocalDateConverter.toJSON(opcoes.inicio),
                fim: LocalDateConverter.toJSON(opcoes.fim),
                tipoDeMovimento: opcoes.tipoDeMovimento,
                tipoDeRelatorio: opcoes.tipoDeRelatorio,
                tipoDeBinario: opcoes.tipoDeBinario
            }
        }

        return this.pkwDatastore.createRecord(Binario, values).save()
    }

    gerarDados(opcoes: OpcoesRelatorio) {
        const filtro = new FiltroExtrato(
            opcoes.inicio,
            opcoes.fim,
            opcoes.empresa && opcoes.empresa.empresa,
            opcoes.operadora
        )

        let gerarVendas = opcoes.tipoDeMovimento === TiposDeMovimentoRelatorio.Vendas
        let gerarRecebimentos =
            opcoes.tipoDeMovimento === TiposDeMovimentoRelatorio.Recebimentos
        let gerarAntecipacoes =
            opcoes.tipoDeMovimento === TiposDeMovimentoRelatorio.Antecipacoes

        if (!opcoes.tipoDeMovimento) {
            gerarVendas = gerarRecebimentos = gerarAntecipacoes = true
        }

        const vendas$ = this.obterDados(ExtratoDeVendas, gerarVendas, filtro)
        const recebimentos$ = this.obterDados(
            ExtratoDeRecebimentos,
            gerarRecebimentos,
            filtro
        )
        const antecipacoes$ = this.obterDados(
            ExtratoDeAntecipacoes,
            gerarAntecipacoes,
            filtro
        )

        return Observable.forkJoin(vendas$, recebimentos$, antecipacoes$).map(
            ([vendas, recebimentos, antecipacoes]) =>
                new DadosRelatorio(vendas, recebimentos, antecipacoes)
        )
    }

    private obterDados<T extends BaseExtratoType>(
        tipoDeExtrato: ExtratoType<T>,
        obterDoServidor: boolean,
        filtro: FiltroExtrato
    ) {
        if (obterDoServidor) {
            return this.pkwDatastore
                .findAll(tipoDeExtrato, {
                    filter: filtro.toFilter(),
                    include: 'empresaQueVendeComCartoes,empresaQueVendeComCartoes.empresa'
                })
                .map(response => response.getModels()) as Observable<T[]>
        }

        return Observable.of(undefined) as Observable<T[]>
    }
}

type BaseExtratoType = ExtratoDeVendas | ExtratoDeRecebimentos | ExtratoDeAntecipacoes

// tslint:disable-next-line:interface-over-type-literal
type ExtratoType<T extends BaseExtratoType> = {
    new (datastore: JsonApiDatastore, data: any): T
}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/relatorio.service.ts